import React from "react";
import { useParams } from 'react-router-dom'
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';

const Index = () => {
  const params = useParams();
  const defaultHeaderConfig = { disableSort: true };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Is Common Wallet',
      value: (row)=>{
        return row.common_wallet ? "True": "False"
      }
    },
  ]

  return <>
    <ListingComponent
      key={'PAGES.CustomersListingPage.name'}
      listingMutation={getApi('groups')}
    className="groups-listing-page"
      contentHeading="Groups List - Results"
      headers={headers}
      recordsKey="groups"
      params= {{fleet_owner_id : params.id}}
      searchBy={['Name']}
    />
  </>
};

export default Index;
